import { useEffect } from 'react';

const siteUrl = 'https://primelawnsnowmanagement.com';

const Seo = ({ title, description, canonical, type = 'website', image = '/images/logo.png', h1 }) => {
  useEffect(() => {
    const canonicalUrl = canonical || `${siteUrl}${window.location.pathname}`;

    document.title = title;

    const updateMeta = (selector, attribute, value) => {
      let meta = document.head.querySelector(selector);
      if (!meta) {
        meta = document.createElement('meta');
        document.head.appendChild(meta);
      }
      meta.setAttribute(attribute, value);
      if (selector === 'meta[name="description"]') meta.setAttribute('name', 'description');
      if (selector === 'meta[property="og:title"]') meta.setAttribute('property', 'og:title');
      if (selector === 'meta[property="og:description"]') meta.setAttribute('property', 'og:description');
      if (selector === 'meta[property="og:type"]') meta.setAttribute('property', 'og:type');
      if (selector === 'meta[property="og:url"]') meta.setAttribute('property', 'og:url');
      if (selector === 'meta[property="og:image"]') meta.setAttribute('property', 'og:image');
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:type"]', 'content', type);
    updateMeta('meta[property="og:url"]', 'content', canonicalUrl);
    updateMeta('meta[property="og:image"]', 'content', `${siteUrl}${image}`);

    let canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    if (h1) {
      let h1Element = document.querySelector('h1.page-title');
      if (!h1Element) {
        h1Element = document.createElement('h1');
        h1Element.className = 'page-title sr-only';
        document.body.prepend(h1Element);
      }
      h1Element.textContent = h1;
    }
  }, [title, description, canonical, type, image, h1]);

  return null;
};

export default Seo;
